import { render, staticRenderFns } from "./RaceCalendar.vue?vue&type=template&id=81e0bd36&scoped=true&"
import script from "./RaceCalendar.vue?vue&type=script&lang=js&"
export * from "./RaceCalendar.vue?vue&type=script&lang=js&"
import style0 from "./RaceCalendar.vue?vue&type=style&index=0&id=81e0bd36&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81e0bd36",
  null
  
)

export default component.exports